import React from 'react';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/24/solid';
import styles from './Table.module.css';

interface PaginationSectionProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

//Table 컴포넌트 페이지 버튼
const PaginationSection: React.FC<PaginationSectionProps> = ({
                                                                 page,
                                                                 totalPages,
                                                                 onPageChange
                                                             }) => {
    const renderPaginationItems = () => {
        const items = [];
        const maxVisible = 5; //페이지 버튼은 한번에 최대 5개
        const halfVisible = Math.floor(maxVisible / 2);

        // 시작 페이지와 끝 페이지 계산
        let start = Math.max(1, page - halfVisible);
        let end = Math.min(totalPages, start + maxVisible - 1);

        // 끝 페이지가 최대 표시 개수보다 적을 경우 시작 페이지 조정
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }

        // 첫 페이지 버튼 추가
        if (start > 1) {
            items.push(1);
            if (start > 2) items.push('...'); // 첫 페이지와 시작 페이지 사이에 간격이 있으면 '...' 추가
        }

        // 중간 페이지 버튼들 추가
        for (let i = start; i <= end; i++) {
            items.push(i);
        }

        // 마지막 페이지 버튼 추가
        if (end < totalPages) {
            if (end < totalPages - 1) items.push('...'); // 끝 페이지와 마지막 페이지 사이에 간격이 있으면 '...' 추가
            items.push(totalPages);
        }

        return items;
    };

    return (
        <div className={styles.pagination}>
            {/*이전 페이지 버튼*/}
            <button
                className={styles.pageButton}
                onClick={() => onPageChange(page - 1)}
                disabled={page <= 1}
            >
                <ChevronLeftIcon className="w-5 h-5"/>
            </button>
            {/*페이지 버튼*/}
            {renderPaginationItems().map((pageNum, index) => (
                <button
                    key={index}
                    className={`${styles.pageNumber} ${
                        page === pageNum ? styles.activePageNumber : ''
                    }`}
                    onClick={() => typeof pageNum === 'number' && onPageChange(pageNum)}
                    disabled={typeof pageNum !== 'number'}
                >
                    {pageNum}
                </button>
            ))}
            {/*다음 페이지 버튼*/}
            <button
                className={styles.pageButton}
                onClick={() => onPageChange(page + 1)}
                disabled={page >= totalPages}
            >
                <ChevronRightIcon className="w-5 h-5"/>
            </button>
        </div>
    );
};

export default PaginationSection;